import {lazyRegister} from "@core/lazyRegister";

lazyRegister.filter('paging', function () {
    return function (input, {page, size}) {
        if (!input || !Array.isArray(input)) return [];

        size = +size || 20;
        page = +page || 1;

        // Công thức tính vị trí bắt đầu cắt mảng
        let start = (page - 1) * size;

        return input.slice(start, start + size);
    };
});
